import React, { useRef } from "react";
import { useMount } from "Hooks";
import { getKeyboardFocusableElements } from "Utils";

/**
 * NoTabFocusWrapper is a React component that wraps its children
 * and disables tab focus for all keyboard-focusable
 * elements within it.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {ReactNode} props.children - The child elements to render inside the wrapper.
 *
 * @example
 * <NoTabFocusWrapper>
 *   <button>Click Me</button>
 *   <input type="text" />
 * </NoTabFocusWrapper>
 *
 * In this example, the button and input will not be focusable via the tab key.
 */
const NoTabFocusWrapper = props => {
  const { children } = props;
  const containerRef = useRef(null);

  useMount(() => {
    const tabFocusableElements = getKeyboardFocusableElements(
      containerRef.current
    );

    tabFocusableElements.forEach(element => {
      element.setAttribute("tabindex", "-1");
    });
  });

  return <section ref={containerRef}>{children}</section>;
};

export default NoTabFocusWrapper;
